import React, { Component } from "react"
import NavBarTop from "./Nav-Top/index"
import "./index.css"

class Header extends Component {
  render() {
    return (
      <header id="header-section">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <NavBarTop />
            </div>
          </div>
        </div>
      </header>
    )
  }
}

export default Header
